var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link content",class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]},on:{"click":function($event){return _vm.handleLinkClick()}}},[_c('Icon',{staticClass:"icon",attrs:{"name":_vm.icon,"width":"30","height":"40"}}),_vm._v(" "),_c('Subtitle',{staticClass:"caption",attrs:{"title":_vm.label}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }